import merge from 'deepmerge'

export default {
  name: 'app',
  methods: {
    // Events
    updateData(data) {
      this[data.key] = typeof data.value === 'object' ? merge(this[data.key], data.value) : data.value
    },
    updateState(state, overrideClass) {
      const enter = `enter${this.routeTo}`
      const from = this.routeFrom ? `From${this.routeFrom}` : ''
      const enterFrom = overrideClass ? overrideClass : enter + from

      switch(state) {
        case 0:
          this.appClasses[enterFrom] = false
          this.appClasses[enterFrom + 'Active'] = false
          this.appClasses[enterFrom + 'To'] = false
          break;
        case 1:
          this.appClasses[enterFrom] = true
          this.appClasses[enterFrom + 'Active'] = true
          this.appClasses[enterFrom + 'To'] = false
          break;
        case 2:
          this.appClasses[enterFrom] = false
          this.appClasses[enterFrom + 'Active'] = true
          this.appClasses[enterFrom + 'To'] = true
          break;
      }
    },
    routeLeave(el, done) { // Call before routeEnter, even in in-out mode
      this.routeFrom = this.routeTo
      this.routeTo = this.$route.name
      this.updateState(1)
      setTimeout(done, 1400)
    },
  },
  created() {
    this.routeTo = this.$route.name
    this.appClasses.minLogo = this.$route.name == 'Work'
    this.appClasses.msSicBrowser = window.isIE
    this.appClasses.iosSicBrowser = window.isIos
    this.updateState(1)
  },
  data() {
    return {
      appClasses: {
        'enterHome': false,
        'enterHomeActive': false,
        'enterHomeTo': false,
        'enterWorkFromHome': false,
        'enterWorkFromHomeActive': false,
        'enterWorkFromHomeTo': false,
        'enterHomeFromWork': false,
        'enterHomeFromWorkActive': false,
        'enterHomeFromWorkTo': false,
        'enterWorkFromWork': false,
        'enterWorkFromWorkActive': false,
        'enterWorkFromWorkTo': false,
        'whiteLogo': false,
        'minLogo': false,
        'hiddenLogo': false,
        'msSicBrowser': false,
        'iosSicBrowser': false,
      },
      routeFrom: '',
      routeTo: '',
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/App.js